import { EditQuestionActionTypes } from './edit-question.types';

export const toggleEditQuestionPageHidden = () => ({
    type: EditQuestionActionTypes.TOGGLE_EDIT_QUESTION_PAGE
});